import React, { useState, useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import useAuth from './useAuth.js';
import './Manage_User.css';
import * as XLSX from 'xlsx';
import Header from './Header.js';
import Sidebar from './Sidebar.js';
import Footer from './Footer.js';
import DatePicker from "react-datepicker";
import './Loader.css';
import Pagination from './Pagination.js';
//import { BASE_URL } from "./Constants.js";
import Finance_Settlement_Reports from './FinanceSettlementReports.js';
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
const Loader = () => (
    <div className="loader-container1">
        <div className="spinner1"></div>
        <p>Loading...</p>
    </div>
);

const Finance_Expence_Reports = () => {
    const [EmpCode, setEmpCode] = useState('');
    const [RptMgr, setRptMgr] = useState('');
    const [items, setItems] = useState([]);
    const [responseMessage, setResponseMessage] = useState('');
    const [is_finance_approval, set_is_finance_approval] = useState(false);
    const [filteredItems, setFilteredItems] = useState([]);
    const [searchQuery, setSearchQuery] = useState('');
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [sortColumn, setSortColumn] = useState('date');
    const [startDate, setStartDate] = useState(null);  // For date picker
    const [endDate, setEndDate] = useState(null);      // For date picker
    const [sortOrder, setSortOrder] = useState('asc');
    const navigate = useNavigate();
    useAuth();

    useEffect(() => {
        const fetchProfileData = async () => {
            try {
                const token = localStorage.getItem('authToken');
                const response = await fetch(`${API_BASE_URL}profile`, {
                    method: 'GET',
                    headers: {
                        'Authorization': `Bearer ${token}`,
                    },
                });

                if (!response.ok) {
                    throw new Error(`HTTP error! Status: ${response.status}`);
                }

                const result = await response.json();

                if (result.status) {
                    setEmpCode(result.profile.emp_code || '');

                    setRptMgr(result.profile.report_mngr || '');
                    set_is_finance_approval(result.profile.is_finance_approval === 'Y');

                    // fetchItems(result.profile.emp_code, result.profile.report_mngr);
                } else {
                    setResponseMessage('Error: ' + result.message);
                }
            } catch (error) {
                console.error('Fetch error:', error);
                setResponseMessage('Error: ' + error.message);
            }
        };

        fetchProfileData();
    }, []);

    useEffect(() => {
        const fetchItems = async () => {
            try {
                const token = localStorage.getItem('authToken');
                if (!token) return;

                const response = await fetch(`${API_BASE_URL}getFinanceexpensereports`, {
                    method: 'GET',
                    headers: {
                        'Authorization': `Bearer ${token}`,
                        'Content-Type': 'application/json'
                    }
                });

                if (!response.ok) {
                    throw new Error(`HTTP error! Status: ${response.status}`);
                }

                const result = await response.json();
                if (result.status) {
                    setItems(result.data);
                } else {
                    setError(result.message);
                }
            } catch (error) {
                console.error('Fetch error:', error);
                setError('Failed to fetch items');
            } finally {
                setLoading(false);
            }
        };

        if (EmpCode) {
            fetchItems();
        }
    }, [EmpCode]);

    useEffect(() => {
        if (!Array.isArray(items)) {
            console.error('items is not an array', items);
            return;
        }
    
        // Date range matching logic
        const filtered = items.filter(item => {
            const matchesSearchQuery = (
                item.emp_code.toLowerCase().includes(searchQuery.toLowerCase()) ||
                item.comp_name.toLowerCase().includes(searchQuery.toLowerCase()) ||
                item.designation_name.toLowerCase().includes(searchQuery.toLowerCase()) ||
                item.month.toLowerCase().includes(searchQuery.toLowerCase()) ||
                item.total_no_of_calls.toLowerCase().includes(searchQuery.toLowerCase()) ||
                item.total_amount.toLowerCase().includes(searchQuery.toLowerCase()) ||
                item.report_mngr.toLowerCase().includes(searchQuery.toLowerCase()) ||
                item.rpt_mgr_status.toLowerCase().includes(searchQuery.toLowerCase()) ||
                item.audit_status.toLowerCase().includes(searchQuery.toLowerCase()) ||
                item.account_status.toLowerCase().includes(searchQuery.toLowerCase())
            );
    
            // Date range matching logic
            const matchesDateRange = (
                (!startDate || new Date(item.account_approved_date).setHours(0, 0, 0, 0) >= new Date(startDate).setHours(0, 0, 0, 0)) &&
                (!endDate || new Date(item.account_approved_date).setHours(23, 59, 59, 999) <= new Date(endDate).setHours(23, 59, 59, 999))
            );
    
            return matchesSearchQuery && matchesDateRange;
        });
    
        // Sorting logic
        const sorted = filtered.sort((a, b) => {
            if (a[sortColumn] < b[sortColumn]) return sortOrder === 'asc' ? -1 : 1;
            if (a[sortColumn] > b[sortColumn]) return sortOrder === 'asc' ? 1 : -1;
            return 0;
        });
    
        setFilteredItems(sorted);
        setCurrentPage(1); // Reset to first page when items or search query changes
    }, [searchQuery, items, sortColumn, sortOrder, startDate, endDate]); // Add startDate and endDate to dependencies
    


    const totalPages = Math.ceil(filteredItems.length / itemsPerPage);
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = filteredItems.slice(indexOfFirstItem, indexOfLastItem);

    const startItem = indexOfFirstItem + 1;
    const endItem = Math.min(indexOfLastItem, filteredItems.length);

    const handleSearchChange = (e) => {
        setSearchQuery(e.target.value);
    };

    const handlePageChange = (pageNumber) => {
        setCurrentPage(pageNumber);
    };

    const handleItemsPerPageChange = (e) => {
        setItemsPerPage(Number(e.target.value));
        setCurrentPage(1);
    };

    const handleSort = (column) => {
        let sortedItems;
        if (column === 'sno') {
            sortedItems = [...items].sort((a, b) => {
                const indexA = items.indexOf(a);
                const indexB = items.indexOf(b);
                return sortOrder === 'asc' ? indexA - indexB : indexB - indexA;
            });
        } else {
            sortedItems = [...items].sort((a, b) => {
                if (a[column] < b[column]) return sortOrder === 'asc' ? -1 : 1;
                if (a[column] > b[column]) return sortOrder === 'asc' ? 1 : -1;
                return 0;
            });
        }

        setItems(sortedItems);
        setSortColumn(column);
        setSortOrder(sortOrder === 'asc' ? 'desc' : 'asc');
    };

    const exportToExcel = () => {
        const filteredBranchNames = filteredItems.map(item => ({
            EmpCode: item.emp_code,
            Name: item.comp_name,
            Designation: item.designation_name,
            Location: item.branch,
            code: item.branch?.split('-')[1],
            Month: item.month,
            Calls: item.total_no_of_calls,
            TotalAmount: Math.trunc(item.total_amount),
            AuditApprovedAmount: Math.trunc(item.audit_approved_amount),
            Transcode: item.trans_code,
            AccountAprdDate: item.account_approved_date,
            // Amount: item.amount,
            // Remarks: item.remarks,
            ManagerStatus: item.rpt_mgr_status,
            AuditStatus: item.audit_status,
            AccountStatus: item.account_status,
        }));

        const worksheet = XLSX.utils.json_to_sheet(filteredBranchNames);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'MonthlyExpenses');
        XLSX.writeFile(workbook, 'Monthly_Expenses.xlsx');
    };

    return (
        <div className="hold-transition sidebar-mini layout-fixed" style={{ fontSize: '12px' }}>
            <div className="wrapper">
                <Header />
                <Sidebar />
                <div className="content-wrapper">
                    <div className="content-header">
                        <div className="container-fluid">
                            <div className="row mb-2">
                                <div className="col-sm-6">
                                    <h4 className="m-0" style={{ fontSize: '20px' }}>Finance Monthly Expense Reports</h4>
                                </div>
                                <div className="col-sm-6">
                                    <ol className="breadcrumb float-sm-right">
                                        <li className="breadcrumb-item" style={{ fontSize: '12px' }}><a href="/dashboard">Home</a></li>
                                        <li className="breadcrumb-item active" style={{ fontSize: '12px' }}>Finance Monthly Expense</li>
                                    </ol>
                                </div>
                            </div>
                        </div>
                    </div>
                    {loading ? (
                        <Loader />
                    ) : (

                        <section className="content">
                            <div className="container-fluid">
                                <div className="row">
                                    <section className="col-lg-12 connectedSortable">
                                        <div className="card">
                                            <div className="card-header">

                                                <span style={{ float: 'right' }}>
                                                    {/* <Link to='/expence_request'>
														<button type='button' className='btn btn-success'>Add New</button>
													</Link> */}
                                                    <button type="button" className="btn btn-secondary ml-2" onClick={exportToExcel}>
                                                        Export to Excel
                                                    </button>
                                                </span>
                                            </div>
                                            <div className="card-body">
                                                {loading ? (
                                                    <Loader /> // Show loader if loading is true
                                                ) : (
                                                    <>
                                                        <div className='row'>
                                                            <div className='col-md-12'>
                                                                {/* Search input */}
                                                                <div id="example1_filter" style={{ float: 'right' }} className="dataTables_filter">
                                                                    <label>
                                                                        <input
                                                                            type="search"
                                                                            value={searchQuery}
                                                                            onChange={handleSearchChange}
                                                                            className="form-control form-control-sm"
                                                                            placeholder="Search"
                                                                            aria-controls="example1"
                                                                        />
                                                                    </label>
                                                                </div>

                                                                {/* Items per page dropdown */}
                                                                <div className="form-group" style={{ display: 'inline-block', marginRight: '15px' }}>
                                                                    <select
                                                                        className="form-control custom-select-sm"
                                                                        value={itemsPerPage}
                                                                        onChange={handleItemsPerPageChange}
                                                                    >
                                                                        <option value={10}>10</option>
                                                                        <option value={50}>50</option>
                                                                        <option value={100}>100</option>
                                                                    </select>
                                                                </div>

                                                                {/* Date filter row */}
                                                                <div className="row" style={{ display: 'inline-flex', justifyContent: 'space-between' }}>
                                                                    <div className="col-md-5">
                                                                        <div className="form-group">
                                                                            <DatePicker
                                                                                selected={startDate}
                                                                                onChange={(date) => setStartDate(date)}
                                                                                selectsStart
                                                                                startDate={startDate}
                                                                                endDate={endDate}
                                                                                dateFormat="yyyy-MM-dd"
                                                                                className="form-control"
                                                                                placeholderText="Select Start Date"
                                                                            />
                                                                        </div>
                                                                    </div>

                                                                    <div className="col-md-5">
                                                                        <div className="form-group">
                                                                            <DatePicker
                                                                                selected={endDate}
                                                                                onChange={(date) => setEndDate(date)}
                                                                                selectsEnd
                                                                                startDate={startDate}
                                                                                endDate={endDate}
                                                                                minDate={startDate}
                                                                                dateFormat="yyyy-MM-dd"
                                                                                className="form-control"
                                                                                placeholderText="Select End Date"
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        {/* Table section */}
                                                        <div className="table-responsive">
                                                            <table className="table table-bordered table-striped" style={{ fontSize: '13px' }}>
                                                                <thead>
                                                                    <tr>
                                                                        <th
                                                                            onClick={() => handleSort("sno")}
                                                                            style={{
                                                                                cursor: 'pointer',
                                                                                backgroundColor: sortColumn === "sno" ? '#f8f9fa' : 'transparent',
                                                                                position: 'relative'
                                                                            }}
                                                                        >
                                                                            S.No {sortColumn === "sno" && (sortOrder === "asc" ? '▲' : '▼')}
                                                                        </th>
                                                                        <th>Emp Code</th>
                                                                        <th>Emp requested Date</th>
                                                                        <th>Accounts Approved Date</th>
                                                                        <th>Trans Code</th>
                                                                        <th>Emp Name</th>
                                                                        <th>Designation</th>
                                                                        <th>Location</th>
                                                                        <th>Code</th>
                                                                        <th>Month</th>
                                                                        <th>Total Calls</th>
                                                                        <th>Total Amount</th>
                                                                        <th>Audit Approved Amount</th>
                                                                        <th>Reporting Manager</th>
                                                                        <th>Finance Status</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {is_finance_approval && currentItems.length > 0 ? (
                                                                        currentItems.some(item => item.rpt_mgr_status !== 'Rejected') ? (
                                                                            currentItems.map((item, index) => (
                                                                                <tr key={index}>
                                                                                    <td>{index + 1 + (currentPage - 1) * itemsPerPage}</td>
                                                                                    <td>{item.emp_code}</td>
                                                                                    <td>
                                                                                        {(() => {
                                                                                            const date = new Date(item.created_on);
                                                                                            const day = String(date.getDate()).padStart(2, '0'); // Get day and pad with leading zero if needed
                                                                                            const month = String(date.getMonth() + 1).padStart(2, '0'); // Get month (0-based index, so add 1) and pad
                                                                                            const year = date.getFullYear(); // Get full year
                                                                                            return `${day}-${month}-${year}`; // Return the formatted date
                                                                                        })()}
                                                                                    </td>
                                                                                    <td>
                                                                                        {(() => {
                                                                                            const date = new Date(item.account_approved_date);
                                                                                            const day = String(date.getDate()).padStart(2, '0'); // Get day and pad with leading zero if needed
                                                                                            const month = String(date.getMonth() + 1).padStart(2, '0'); // Get month (0-based index, so add 1) and pad
                                                                                            const year = date.getFullYear(); // Get full year
                                                                                            return `${day}-${month}-${year}`; // Return the formatted date
                                                                                        })()}
                                                                                    </td>
                                                                                    <td>{item.trans_code}</td>
                                                                                    <td>{item.comp_name}</td>
                                                                                    <td>{item.designation_name}</td>
                                                                                    <td>{item.branch}</td>
                                                                                    <td>{item.branch?.split('-')[1]}</td>
                                                                                    <td>{item.month}</td>
                                                                                    <td>{item.total_no_of_calls}</td>
                                                                                    <td>{Math.trunc(item.total_amount)}</td>
                                                                                    <td>{Math.trunc(item.audit_approved_amount)}</td>
                                                                                    <td>{item.report_mngr}</td>
                                                                                    <td style={{ color: item.account_status === 'Pending' ? 'orange' : item.account_status === 'Approved' ? 'green' : item.account_status === 'Rejected' ? 'red' : 'inherit' }}>
                                                                                        {item.account_status}
                                                                                    </td>
                                                                                </tr>
                                                                            ))
                                                                        ) : (
                                                                            <tr>
                                                                                <td colSpan="15" style={{ textAlign: 'center' }}>No data available</td>
                                                                            </tr>
                                                                        )
                                                                    ) : (
                                                                        <tr>
                                                                            <td colSpan="15" style={{ textAlign: 'center' }}>No data available</td>
                                                                        </tr>
                                                                    )}
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                    </>
                                                )}
                                            </div>

                                        </div>
                                        <Pagination
                                            currentPage={currentPage}
                                            totalPages={totalPages}
                                            handlePageChange={handlePageChange}
                                        />
                                        <div className="mb-3">
                                            Showing {startItem} to {endItem} of {filteredItems.length} entries
                                        </div>
                                    </section>
                                </div>
                            </div>
                        </section>
                    )}
                </div>
                <Footer />
            </div>
        </div>
    );
};

export default Finance_Expence_Reports;
